import { ScheduleSessionAvailabilityResponse } from './schedule.types';

/** Raw shape of POST /ScheduleSession/{studentId}/hours/{date}; the API names the goal count `minGoalsCount`. */
export type HoursValidationApiResponse =
  | { canSchedule: true; minGoalsCount?: number }
  | { canSchedule: false; message: string };

export const mapHoursValidationResponse = (
  response: HoursValidationApiResponse,
): ScheduleSessionAvailabilityResponse =>
  response.canSchedule
    ? { canSchedule: true, requiredGoals: response.minGoalsCount }
    : { canSchedule: false, message: response.message };
